<section
  class="signal-mesh"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-intensity-input]="intensity"
  [style.--scene-speed-input]="speed"
  [style.--mesh-columns]="columns.length"
  [style.--mesh-rows]="rows.length"
>
  <div class="mesh-grid">
    <span
      *ngFor="let left of verticalLines"
      class="mesh-line mesh-line-vertical"
      [style.left]="left"
    ></span>

    <span
      *ngFor="let top of horizontalLines"
      class="mesh-line mesh-line-horizontal"
      [style.top]="top"
    ></span>

    <span
      *ngFor="let node of nodes"
      class="mesh-node"
      [style.left]="node.left"
      [style.top]="node.top"
      [style.animation-delay]="node.delay"
      [style.animation-duration]="node.duration"
    ></span>
  </div>

  <div class="mesh-glow mesh-glow-a"></div>
  <div class="mesh-glow mesh-glow-b"></div>
</section>
